var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrap",staticClass:"infinite-scroll-wrap"},[_vm._t("default",null,{"items":_vm.items,"modelIds":_vm.modelIds,"isLoading":_vm.isLoading})],2)}
var staticRenderFns = []

export { render, staticRenderFns }